import React from 'react';

import { bemCssModules, getTestId } from '@utils';

import { CryptoCurrencyEnum } from '@modules/global/types';

import Currency from '../Currency';

import style from './Section.scss';

const cn = bemCssModules(style, 'Section');
const ti = getTestId('Section');

export type TSection = {
  currencies: CryptoCurrencyEnum[];
  title?: string;
};

const Section: CustomFC<TSection> = React.memo(({ currencies, title, className }) => {
  return (
    <div className={cn([className])} data-testid={ti()}>
      {title && <h3 className={cn('title')}>{title}</h3>}
      <div className={cn('list')}>
        {currencies.map(currency => (
          <Currency key={currency} currency={currency} />
        ))}
      </div>
    </div>
  );
});

export default Section;
